import styled from '@emotion/styled'
import { useReactiveVar } from '@apollo/client'
import { Tab, Tabs } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCloudUploadAlt } from '@fortawesome/free-solid-svg-icons'

import { MatchSource } from 'src/graphql/types'
import { activeMatchSource } from 'src/hooks/use-matches'
import { ReactComponent as FaceitIcon } from 'src/assets/icons/faceit-pheasant.svg'
import { ReactComponent as SteamIcon } from 'src/assets/icons/steam-icon.svg'

const iconSize = 18

const sourceTabs = [
  {
    source: MatchSource.Steam,
    labelKey: 'matches:source_tabs:steam',
    icon: <SteamIcon width={iconSize} height={iconSize} />
  },
  {
    source: MatchSource.Faceit,
    labelKey: 'matches:source_tabs:faceit',
    icon: <FaceitIcon width={iconSize} height={iconSize} />
  },
  {
    source: MatchSource.Upload,
    labelKey: 'matches:source_tabs:upload',
    icon: (
      <FontAwesomeIcon icon={faCloudUploadAlt} style={{ fontSize: iconSize }} />
    )
  }
]

export function SourceTabs() {
  const { t } = useTranslation()
  const source = useReactiveVar(activeMatchSource)

  return (
    <StyledTabs
      value={source}
      onChange={(_, value: MatchSource) => activeMatchSource(value)}
      aria-label={t('matches:source_tabs:aria_label')}
      indicatorColor='secondary'
    >
      {sourceTabs.map((tab) => (
        <StyledTab
          key={tab.source}
          value={tab.source}
          label={t(tab.labelKey)}
          icon={tab.icon}
          iconPosition='start'
        />
      ))}
    </StyledTabs>
  )
}

const StyledTabs = styled(Tabs)`
  border-bottom: 1px solid ${(props) => props.theme.d.colors.border.dark};
  min-height: 44px;

  .MuiTabs-flexContainer {
    gap: ${(props) => props.theme.d.spacing[2]};
  }
`

const StyledTab = styled(Tab)`
  color: ${(props) => props.theme.d.colors.text.primary};
  background: ${(props) => props.theme.d.colors.button.secondary};
  border: 1px solid ${(props) => props.theme.d.colors.border.dark};
  border-bottom: none;
  border-radius: 4px 4px 0 0;
  text-transform: none;
  font-size: 15px;
  min-height: 44px;
  padding: 8px 20px;
  gap: 8px;

  &.Mui-selected {
    color: ${(props) => props.theme.d.colors.text.secondary};
    font-weight: 700;
    border-color: ${(props) => props.theme.d.colors.button.primary};
    background: ${(props) =>
      props.theme.d.colors.gridViewButtonActiveBackground};
  }
`
